/**
 * Authoring-boundary text normalization.
 *
 * LLM/tool-authored strings frequently arrive with literal backslash
 * escapes where control characters were meant — a JSON payload
 * double-escaped somewhere between the model and the commit ("Line 1\\n
 * Line 2" rendering as visible `\n` glyphs).
 *
 * The RUNTIME renders authored data verbatim — every client (web, Unity)
 * must agree on what a string means, and "backslash-n becomes a newline"
 * is a tool-input concern, not part of the scene format. So this helper
 * lives in the editor layer and must be applied where tool input enters
 * the scene (AI behavior tools, spatial-code helpers, template
 * converters) — BEFORE the text is committed. Human editor input needs
 * no normalization: a person who types `\n` means a backslash and an n.
 */
export function normalizeAuthoredText(text: string): string {
    return text.replace(/\\n/g, '\n').replace(/\\t/g, '  ');
}
